module.exports = __webpack_public_path__ + "img/3.e5d7244d.png";